/* ==========================================================================
   PUJA WISHLIST
   Is file ko "assets" folder me "puja-wishlist.js" naam se upload karo.
   Ye browser ki localStorage me wishlist save karta hai, par ab login
   zaroori hai — har customer ki apni alag list hoti hai (customer ID se
   namespaced), taaki same device pe alag logins ka data mix na ho.
   ========================================================================== */
(function () {
  if (window.__pujaWishlistInit) return;
  window.__pujaWishlistInit = true;

  var isLoggedIn = window.PujaCustomerLoggedIn === true;
  var customerId = window.PujaCustomerId || 'guest';
  var loginUrl = window.PujaLoginUrl || '/account/login';

  // Login page par seedha redirect (window.location) karne se phone-OTP app ka
  // popup nahi khulta, kyunki wo app asli login LINK ke click ko pakadti hai.
  // Isliye hum ek asli link banakar uspe click karte hain.
  function goToLogin() {
    var existing = document.querySelector(
      'a[href*="/account/login"], a[href*="customer_authentication/login"]'
    );
    if (existing) {
      existing.click();
      return;
    }
    var a = document.createElement('a');
    a.href = loginUrl;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      if (a.parentNode) a.parentNode.removeChild(a);
    }, 0);
  }
  window.PujaGoToLogin = goToLogin;
  var STORAGE_KEY = 'puja_wishlist_' + customerId;

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage blocked, ignore silently */
    }
  }

  function isWishlisted(id) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function toggleWishlist(item) {
    var list = getWishlist();
    var index = list.findIndex(function (i) {
      return String(i.id) === String(item.id);
    });
    var added;
    if (index > -1) {
      list.splice(index, 1);
      added = false;
    } else {
      list.push(item);
      added = true;
    }
    saveWishlist(list);
    document.dispatchEvent(new CustomEvent('puja:wishlist-updated', { detail: { list: list } }));
    return added;
  }

  function paintAllButtons() {
    document.querySelectorAll('[data-puja-wishlist-btn]').forEach(function (btn) {
      btn.classList.toggle('active', isWishlisted(btn.dataset.productId));
    });
    paintCountBadges();
  }

  function paintCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-puja-wishlist-count]').forEach(function (badge) {
      var textEl = badge.querySelector('[data-puja-wishlist-count-text]') || badge;
      textEl.textContent = count;
      badge.hidden = count === 0;
    });
  }

  // Event delegation — naye cards baad me add hone par bhi kaam karega
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-puja-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();

    if (!isLoggedIn) {
      goToLogin();
      return;
    }

    var item = {
      id: btn.dataset.productId,
      handle: btn.dataset.productHandle || '',
      title: btn.dataset.productTitle || '',
      image: btn.dataset.productImage || '',
      price: btn.dataset.productPrice || ''
    };

    var added = toggleWishlist(item);
    btn.classList.toggle('active', added);
    paintCountBadges();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAllButtons);
  } else {
    paintAllButtons();
  }

  // Dusri scripts (jaise ek wishlist count badge) ke liye expose karna
  window.PujaWishlist = {
    getWishlist: getWishlist,
    toggleWishlist: toggleWishlist,
    isWishlisted: isWishlisted
  };
})();